import { PdfLight } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { useSelector } from 'react-redux'

import { useExportAsPdf } from '@/hooks'
import { selectIsLoading } from '@/store'
import { ExportItem } from '../ExportItem'

interface Props {
  exportable: boolean
}

export const ExportPdf: React.FC<Props> = ({ exportable }) => {
  const pdfLoading = useSelector(selectIsLoading('export_pdf'))

  const onClick = useExportAsPdf()

  return (
    <ExportItem
      label="PDF"
      exportable={exportable}
      loading={pdfLoading}
      icon={PdfLight}
      onClick={onClick}
    />
  )
}
